import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Estepona"
      slug="estepona"
      poblacion={79539}
      lat={36.4276}
      lng={-5.1453}
      neighborhoodsText="Cubrimos Estepona capital, El Padrón, Cancelada, Selwo, Bahía Dorada, Costalita y la New Golden Mile. Especialistas en villas y edificios premium."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Estepona?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Estepona?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés y francés." },
      ]}
    />
  );
}